// src/components/Layout/ThemeToggleButton.js
import React from 'react';
import { ActionIcon, useMantineColorScheme, Tooltip } from '@mantine/core';
import { IconSun, IconMoonStars } from '@tabler/icons-react';

function ThemeToggleButton() {
  // useMantineColorScheme hook provides colorScheme and setColorScheme
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';

  const handleToggle = () => {
    setColorScheme(isDark ? 'light' : 'dark');
  };

  return (
    <Tooltip label={isDark ? 'Switch to light mode' : 'Switch to dark mode'} withArrow>
      <ActionIcon
        variant="outline"
        color={isDark ? 'yellow' : 'blue'}
        onClick={handleToggle} // Use the new handler
        title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        size="lg"
        radius="md"
      >
        {isDark ? <IconSun size="1.2rem" /> : <IconMoonStars size="1.2rem" />}
      </ActionIcon>
    </Tooltip>
  );
}

export default ThemeToggleButton;